<template>

<v-dialog v-model="dialog" width="500px">
  <v-card>
    <p class=".title ma-2">Add a line to invoice {{hefr.hefc_code }} </p>
    <v-form ref="addHefr" v-model="addHefrValid">
     
     <v-row no-gutters>
      <v-col class="ma-2">
       <v-select v-model="hefr.hfrt_code" :items="hfrt_codeKeuzes" item-value="hfrt_code" item-text="hfrttaal_oms" label="Item" dense></v-select>
      </v-col>
     </v-row>

     <v-row no-gutters>
      <v-col class="ma-2">
       <v-text-field v-model="hefr.hefr_oms" label="Description" dense></v-text-field>
      </v-col>
     </v-row>    

     <v-row no-gutters>
      <v-col class="ma-2">
       <v-text-field v-model="hefr.hefr_bedrag_excl" label="Amount excl VAT" prefix="EUR" dense></v-text-field>
      </v-col>
     </v-row>    
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addHefr" :disabled="!addHefrValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      addHefrValid: false,
      hefc_encrid: null,
      hfrt_codeKeuzes: [],
      hefr: {},
      hfrt_codeRules: [
          v => (v && v.length >= 3) || "An Item is requird"
      ]
    }
  },
  methods: {
    open(hefc_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/eign/hefc/hefr/getHefcToAddHefr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHefcToAddHefr"
          },
          getHefcToAddHefr: {
            hefc_encrid: hefc_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hefr = res.data.getHefcToAddHefr;
            res.data.getHefcToAddHefr.hfrt_codeKeuzes.forEach(function(hfrt) {
            deze.hfrt_codeKeuzes.push(hfrt); 
           });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addHefr() { 
      this.$axios
        .post("ares/json/ares/eign/hefc/hefr/addHefr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addHefr"
          },
          addHefr: {
            hefc_encrid: this.hefr.hefc_encrid,
            hfrt_code: this.hefr.hfrt_code,
            hefr_oms: this.hefr.hefr_oms,
            hefr_bedrag_excl: parseFloat(this.hefr.hefr_bedrag_excl)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 

             if (res.data.addHefr.color == "success") { 
                setTimeout(() => { this.$router.reload('/eign/hefc/onHefcTmp/' + res.data.addHefr.hefc_encrid);  }, 2000);      
             }         
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addHefr.text,
              color: res.data.addHefr.color
            }); 
            this.dialog = false;
          }
        })
    },
  }
}
</script>

